import React from 'react';
import classnames from 'classnames';
import ButtonNew from 'components/inputs/ButtonNew';
import './ModalFooter.scss';

const ModalFooter = ({
  secondaryAction,
  secondaryActionLabel,
  secondaryActionDisabled,
  primaryAction,
  primaryActionLabel,
  primaryActionDisabled,
  tertiaryAction,
  tertiaryActionLabel,
  tertiaryActionDisabled,
}) => {
  return (
    <div className="ModalFooter">
      <div className="ModalFooter-button-container">
        {tertiaryAction ? (
          <ButtonNew
            buttonClasses={classnames(
              'secondary-button-small ModalFooter-cancel-button',
              {
                disabled: tertiaryActionDisabled,
              }
            )}
            label={tertiaryActionLabel}
            onClick={tertiaryAction}
          />
        ) : null}
      </div>
      <div className="ModalFooter-button-container">
        {secondaryAction ? (
          <ButtonNew
            buttonClasses={classnames(
              'secondary-button-small ModalFooter-cancel-button tour-experiment-cancel',
              {
                disabled: secondaryActionDisabled,
              }
            )}
            label={secondaryActionLabel}
            onClick={secondaryAction}
          />
        ) : null}
        {primaryAction ? (
          <ButtonNew
            label={primaryActionLabel}
            buttonClasses={classnames('primary-button-small', {
              disabled: primaryActionDisabled,
            })}
            onClick={primaryAction}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ModalFooter;
